<template>
  <div class="privacyPolicy">
    <h1 class="privacyPolicy1" v-html="title"></h1>
    <div class="privacyPolicy2" v-html="cont">

    </div>
  </div>
</template>

<script>

export default {
  name: "privacyPolicy",
  components: {
  },
  props: ["langType"],
  watch: {
    langType: function (type) {
      this.getCon(type);
    },
  },
  created: function(){
    // this.getCon(this.$i18n.locale);
  },
  mounted: function () {
    var lan = navigator.language;
    console.log(lan);
    if(lan == 'zh-CN'){
      this.getCon('zh')
    }else{
      this.getCon('en')
    }
  },
  methods: {
    getCon(type) {
      this.$post("/halababy/loofox/privacy").then((res) => {
        if (type == "zh") {
          this.title = res.data['title'];
          this.cont = res.data['content'];
        }else{
          this.title = res.data['titleEn'];
          this.cont = res.data['contentEn'];
        }
      });
    },
  },
  data() {
    return {
      title:"",
      cont:""
    };
  },
};
</script>

<style>
.privacyPolicy {
  width: 1200px;
  background-color: white;
  margin: auto;
}
.privacyPolicy1 {
  margin: 0;
  padding-top: 100px;
}

.privacyPolicy2{
  font-size: 16px;
  margin-top: 30px;
  line-height: 20px;
  color: #6F6F6F;
  text-align: left;
  padding-bottom: 100px;

}

.privacyPolicy2 p{
  text-indent: 25px;
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/privacyPolicy.vue